/**
 * File: src/components/game-card.js
 * Mô tả: Component thẻ hiển thị thông tin game với liên kết chuyển hướng URL riêng (/games/:id), hỗ trợ i18n.
 * Liên quan: src/i18n/i18n-service.js, src/data/games.js, src/utils/media.js
 */

import { createElement } from '../utils/dom.js';
import { handleImageError } from '../utils/media.js';
import { getLanguage, t } from '../i18n/i18n-service.js';

export const renderGameCard = (game) => {
  const card = createElement('article', { className: 'game-card' });
  const detailUrl = `/games/${game.id}`;
  const lang = getLanguage();

  const shortDesc = lang === 'en' && game.id === 'ant-clash'
    ? 'A 2D real-time strategy game where you command an ant colony to battle termites and conquer nests.'
    : (lang === 'en' ? game.shortDescriptionEn : null) || game.shortDescription;

  card.innerHTML = `
    <a href="${detailUrl}" class="card-media" aria-label="${t('showcase.viewDetails')} ${game.title}">
      <img src="${game.coverImage}" alt="${game.title} Cover" />
    </a>
    <div class="card-body">
      <span class="card-genre">${lang === 'en' ? game.genreEn || game.genre : game.genre}</span>
      ${game.releaseDateEn ? `<span class="card-status">${lang === 'en' ? game.releaseDateEn : game.releaseDate}</span>` : ''}
      <h3 class="card-title">
        <a href="${detailUrl}">${game.title}</a>
      </h3>
      <p class="card-desc">${shortDesc}</p>
      <a href="${detailUrl}" class="btn btn-secondary card-action-btn" aria-label="${t('showcase.viewDetails')} ${game.title}">
        <span>${t('showcase.viewDetails')}</span>
        <span>→</span>
      </a>
    </div>
  `;

  const img = card.querySelector('img');
  handleImageError(img);

  return card;
};
